import {
    comparaRegrasDepAtuaisComDepUpSell,
    retornaLabelDoValorParentesco,
    validatorEstrtutura1, validatorMaiorIgual65Anos,
    validatorParentescoEmDuplicidade,
    validatorPossui10Dependentes
} from './funcoesAuxiliaresZISF';

export class CorrenteCadastroZISF {
    constructor(dependentes, parentesco, categorias, valoresForm, idadeAssociado, subGrupoSelecionadoUpSell) {
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.idadeAssociado = idadeAssociado;
        this.subGrupoSelecionadoUpSell = subGrupoSelecionadoUpSell;

        if (subGrupoSelecionadoUpSell) {
            this.dependentes = dependentes.filter(dependente => dependente.Status === true);
        } else {
            this.dependentes = dependentes;
        }
    }

    validarRegrasDepAtuaisComDepUpSell() {
        if (this.dependentes.length && this.subGrupoSelecionadoUpSell) {
            const comparacaoDepAtualDepUpSell = comparaRegrasDepAtuaisComDepUpSell(this.dependentes, this.subGrupoSelecionadoUpSell, this.idadeAssociado);

            if (comparacaoDepAtualDepUpSell) {
                this.arrayMsgsErro = [
                    ...this.arrayMsgsErro,
                    comparacaoDepAtualDepUpSell
                ];
            }
        }

        return this;
    }

    possui2DependentesMaiorIgual65Anos() {
        if (validatorMaiorIgual65Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('O plano ZELO IDEAL SAF permite apenas 2 dependentes com idade maior ou igual a 65 anos.');
        }

        return this;
    }

    dependentesDentroDaEstrutura1() {
        if (this.dependentes.length && this.valoresForm.Idade) {
            if (this.valoresForm.Parentesco && validatorEstrtutura1(this.valoresForm, this.dependentes)) {
                this.arrayMsgsErro.push('O plano ZELO IDEAL SAF permite somente dependentes do tipo cônjuge, pai, mãe, sogro, sogra, filhos de até 30 anos');
            }
        }

        return this;
    }

    possui10Dependentes() {
        if (validatorPossui10Dependentes(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('O plano ZELO IDEAL SAF permite apenas 10 dependentes');
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(`${retornaLabelDoValorParentesco(this.parentesco)}`);
        }

        return this;
    }
}
